import { instance } from './config';

export const getTokenById = (tokenId) => {
   return instance.get('/token/id/' + tokenId);
};

export const getTokensByDates = (startDate, endDate) => {
   return instance.get('/token/dates', {
      params: {
         startDate: startDate,
         endDate: endDate,
      },
   });
};

export const getTokenByTransactionId = (transactionId) => {
   return instance.get(`/token/transaction/${transactionId}`);
};

export const reprintTokenList = (requestData) => {
   return instance.post('/token/suprima/list', requestData);
};

export const reprintToken = (requestData) => {
   return instance.post('/token/suprima/reprint', requestData);
};
